interface IArticleContent {
  [props: number]: {
    value: string
    label?: string
    schemaPath?: string
  }
}

const ARTICLE_CONTENT_TYPE: IArticleContent = {
  0: {
    value: 'unknown',
  },
  1: {
    value: 'pgc_article',
  },
  2: {
    value: 'pgc_video',
  },
  3: {
    value: 'pgc_artivideo',
  },
  4: {
    value: 'pgc_article',
  },
  5: {
    value: 'ugc_text',
  },
  6: {
    value: 'ugc_video',
  },
  7: {
    value: 'ugc_article',
  },
  8: {
    value: 'ugc_qa',
  },
  9: {
    value: 'ugc_long_article',
  },
  10: {
    value: 'ugc_vote',
  },
  11: {
    value: 'ugc_transmit',
  },
  12: {
    value: 'long_reputation',
  },
  13: {
    value: 'reputation',
  },
}

export default ARTICLE_CONTENT_TYPE
